import { render, staticRenderFns } from "./Padlock.vue?vue&type=template&id=433f5691&"
import script from "./Padlock.vue?vue&type=script&setup=true&lang=js&"
export * from "./Padlock.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports